<template>
  <xr-create
    :loading="loading"
    :title="title"
    @close="close"
    @save="saveClick">
    <!-- <i slot="title-append" class="wk wk-icon-fill-help wk-help-tips" data-type="9" data-id="36" /> -->
    <create-sections title="基本信息">
      <el-form
        ref="crmForm"
        :model="fieldForm"
        :rules="fieldRules"
        :validate-on-rule-change="false"
        class="wk-form"
        label-position="top">
        <wk-form-items
          v-for="(children, index) in fieldList"
          :key="index"
          :field-from="fieldForm"
          :field-list="children"
          @change="formChange">
          <template slot-scope="{ data }">
            <crm-relative-cell
              v-if="data && data.formType === 'customer'"
              :value="fieldForm[data.field]"
              :disabled="data.disabled"
              is-admin
              relative-type="customer"
              @value-change="otherChange($event, data)" />
            <crm-relative-cell
              v-else-if="data && data.formType === 'contacts'"
              :value="fieldForm[data.field]"
              :disabled="data.disabled"
              :relation="customerParams"
              relative-type="contacts"
              @value-change="otherChange($event, data)" />
          </template>
        </wk-form-items>
      </el-form>
    </create-sections>
  </xr-create>
</template>

<script>
import { filedGetFieldAPI, crmSpecialExamineAPI } from '@/api/crm/common'
import { crmContactsSaveAPI } from '@/api/crm/contacts'

import XrCreate from '@/components/XrCreate'
import CreateSections from '@/components/CreateSections'
import WkFormItems from '@/components/NewCom/WkForm/WkFormItems'
import {
  CrmRelativeCell
} from '@/components/CreateCom'

import crmTypeModel from '@/wkcrmViews/crm/model/crmTypeModel'
import CustomFieldsMixin from '@/mixins/CustomFields'
import { isEmpty } from '@/utils/types'
import ExamineMixin from '../mixins/Examine'

export default {
  // 新建编辑
  name: 'ContactsCreate',

  components: {
    XrCreate,
    CreateSections,
    CrmRelativeCell,
    WkFormItems
  },

  mixins: [CustomFieldsMixin, ExamineMixin],

  props: {
    phone: String,
    action: {
      type: Object,
      default: () => {
        return {
          type: 'save',
          id: '',
          data: {}
        }
      }
    }
  },

  data() {
    return {
      loading: false,
      baseFields: [],
      fieldList: [],
      fieldForm: {},
      fieldRules: {},
      customerParams: {
        params: {},
        moduleType: 'customer'
      }
    }
  },

  computed: {
    title() {
      return this.action.type === 'update' ? '编辑联系人' : '新建联系人'
    }
  },

  watch: {},

  created() {
    this.getField()
  },

  mounted() {},

  beforeDestroy() {},

  methods: {
    /**
     * 获取数据
     */
    getField() {
      this.loading = true
      const params = {
        label: crmTypeModel.contacts
      }

      if (this.action.type == 'update') {
        params.id = this.action.id
      }

      filedGetFieldAPI(params)
        .then(res => {
          const list = res.data || []
          if (!isEmpty(this.phone)) {
            list.forEach(children => {
              children.forEach(item => {
                if (item.formType === 'mobile') {
                  item.defaultValue = this.phone
                }
              })
            })
          }

          const assistIds = this.getFormAssistIds(list)

          const baseFields = []
          const fieldList = []
          const fieldForm = {}
          list.forEach(children => {
            const fields = []
            children.forEach(item => {
              // action.data传入{fieldId:value}的键值对时，覆盖原有值
              this.action.data && this.action.data[item.fieldId] && (item.value = item.defaultValue = this.action.data[item.fieldId] || '')

              const temp = this.getFormItemDefaultProperty(item)
              temp.show = !assistIds.includes(item.formAssistId)
              // 是否可编辑
              const canEdit = this.getItemIsCanEdit(item, this.action.type)
              // 是否禁用
              temp.disabled = !canEdit
              if (params.id && temp.name === '联系人状态') {
                // 如果是编辑情况，联系人类型字段不可编辑
                temp.disabled = true
                if (this.action.data && this.action.data.specialExamine) {
                  // 发起转精准联系人审批
                  item.value = item.defaultValue = '精准联系人'
                }
              }

              // 禁止某些业务组件选择
              if (temp.formType === 'customer') {
                if (this.action.type === 'relative') {
                  const relativeDisInfos = {
                    customer: { customer: true },
                    business: { customer: true }
                  }

                  // 在哪个类型下添加
                  const relativeTypeDisInfos = relativeDisInfos[this.action.crmType]
                  if (relativeTypeDisInfos) {
                  // 包含的字段值
                    temp.disabled = relativeTypeDisInfos[item.formType] || false
                  }
                }
              }

              // 特殊字段允许多选
              this.getItemRadio(item, temp)

              // 获取默认值
              if (temp.show) {
                fieldForm[temp.field] = this.getItemValue(item, this.action.data, this.action.type)
              }
              fields.push(temp)
              baseFields.push(item)
            })
            fieldList.push(fields)
          })

          this.baseFields = baseFields
          this.fieldList = fieldList
          this.fieldForm = fieldForm
          this.fieldRules = this.getFormRulesByOptionsChange(this.fieldList, this.fieldForm)

          // 没有选择客户时，联系人禁止选择直属上级
          const flag = isEmpty(this.fieldForm.customerId)
          if (!flag) {
            this.customerParams.params = {
              customerId: this.fieldForm.customerId[0].customerId
            }
          } else {
            this.customerParams.params = {}
          }
          this.fieldList.forEach(children => {
            children.forEach(child => {
              if (child.fieldName === 'parentContactsId') {
                this.$set(child, 'disabled', flag)
              }
            })
          })

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    /**
     * 保存
     */
    saveClick() {
      this.loading = true
      const crmForm = this.$refs.crmForm
      crmForm.validate(valid => {
        if (valid) {
          const params = this.getSubmiteParams([].concat.apply([], this.fieldList), this.fieldForm)
          this.submiteParams(params)
        } else {
          this.loading = false
          // 提示第一个error
          this.getFormErrorMessage(crmForm)
          return false
        }
      })
    },

    /**
     * 提交上传
     */
    submiteParams(params) {
      if (this.action.type == 'update') {
        params.entity.contactsId = this.action.id
        params.entity.batchId = this.action.batchId
      }

      // 区别是编辑精准还是发起精准
      if (this.action.data && this.action.data.isTrans) {
        params.isTrans = 1 // 1 发起精准审批 0 编辑精准
      } else {
        params.isTrans = 0
      }

      // 相关添加时候的多余提交信息
      if (
        this.action.relativeData &&
        Object.keys(this.action.relativeData).length
      ) {
        params = { ...params, ...this.action.relativeData }
      }
      crmContactsSaveAPI(params)
        .then(res => {
          this.loading = false
          if (params.field.some(item => (item.name === '联系人状态' && item.value === '精准联系人'))) {
            crmSpecialExamineAPI({
              businessType: 1, // 业务类型  1 联系人  2 企业
              businessId: res.data ? res.data.contactId : this.action.id
            }).then(async({ data }) => {
              const examine = data.filter(item => item.examineType === 1 && !!item.canInitiate)
              // 接口返回是否需要发起精准联系人审批
              if (examine && examine.length) {
                await this.$confirm('是否发起转精准联系人审批?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.postSpecialExamine(examine[0].examineType, { contactsIds: res.data.contactId }, examine[0].examineId, res.data.contactName, '', () => {
                    this.submitComplete(false)
                  })
                }).catch(() => {
                  this.submitComplete()
                })
              } else {
                this.submitComplete()
              }
            }).catch(() => {
              this.submitComplete()
            })
          } else {
            this.submitComplete()
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    submitComplete(showMessage = true) {
      showMessage && this.$crmMessage.success(
        this.action.type == 'update' ? '编辑成功' : '添加成功'
      )
      this.close()
      // 保存成功
      this.$emit('save-success', {
        type: 'contacts'
      })
    },

    /**
     * 验证唯一
     */
    UniquePromise({ field, value }) {
      return this.getUniquePromise(field, value, this.action)
    },

    /**
     * change
     */
    formChange(field, index, value, valueList) {
      if ([
        'select',
        'checkbox'
      ].includes(field.formType) &&
          field.remark === 'options_type' &&
          field.optionsData) {
        const { fieldForm, fieldRules } = this.getFormContentByOptionsChange(this.fieldList, this.fieldForm)
        this.fieldForm = fieldForm
        this.fieldRules = fieldRules
      }

      this.fieldRules = this.getFormRulesByOptionsChange(this.fieldList, this.fieldForm)
    },

    otherChange(data, field) {
      // 修改客户
      if (field.fieldName === 'customerId') {
        let flag = false
        let customerId = null
        if (data.value.length) {
          customerId = data.value[0].customerId
          this.customerParams.params = { customerId }
          flag = false
        } else {
          this.customerParams.params = {}
          flag = true
        }

        // 修改客户后清空联系人的直属上级
        if (
          this.fieldForm.hasOwnProperty('parentContactsId') &&
          customerId !== this.fieldForm.parentContactsId
        ) {
          this.$set(this.fieldForm, 'parentContactsId', [])
        }

        this.fieldList.forEach(children => {
          children.forEach(child => {
            if (child.fieldName === 'parentContactsId') {
              this.$set(child, 'disabled', flag)
            }
          })
        })
      }

      // 修改直属上级
      if (field.fieldName === 'parentContactsId') {
        if (data.value.length) {
          const contactsId = data.value[0].contactsId
          if (this.action.id && this.action.id == contactsId) {
            this.$crmMessage.error('不能选择本人作为上级')
            this.$set(this.fieldForm, field.field, [])
            return
          }
        }
      }

      this.$set(this.fieldForm, field.field, data.value)
      this.$refs.crmForm.validateField(field.field)
    },

    /**
     * 关闭
     */
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
